/* Sprint 2R-4A — Compliance status banner shown in the vognmand portal. */
import React from "react";
import { scApi } from "../lib/api";
import { CheckCircle2, AlertCircle, ChevronRight } from "lucide-react";

const STATUS_LABEL = {
  not_started: "Ikke startet",
  in_progress: "Igang",
  submitted: "Afventer godkendelse",
  needs_more_info: "Mangler info",
  approved: "Godkendt",
  rejected: "Afvist",
  blocked: "Blokeret",
};

export default function VognmandComplianceBanner() {
  const [state, setState] = React.useState(null);

  React.useEffect(() => {
    let m = true;
    scApi().get("/sc/onboarding/state").then((r) => { if (m) setState(r.data); }).catch(() => {});
    return () => { m = false; };
  }, []);

  if (!state) return null;

  if (state.onboarding_status === "approved") {
    const missingVehicle = (state.approved_vehicle_count ?? 0) < 1 && !state.vehicle_requirement_exempt;
    return (
      <div className={`${missingVehicle ? "bg-amber-50 border-amber-200 text-amber-900" : "bg-emerald-50 border-emerald-200 text-emerald-900"} border px-4 py-2 text-xs`}
           data-testid="vognmand-compliance-banner">
        <div className="flex items-center gap-2">
          {missingVehicle ? <AlertCircle size={14}/> : <CheckCircle2 size={14}/>}
          <span>Onboarding godkendt · aftale version {state.agreement_version_signed} · {STATUS_LABEL[state.onboarding_status]}</span>
        </div>
        {missingVehicle && (
          <div className="mt-1 font-semibold" data-testid="banner-vehicle-missing">
            ⚠ Du mangler at få godkendt mindst ét køretøj, før du kan modtage ruter.
          </div>
        )}
      </div>
    );
  }

  const tone = state.onboarding_status === "rejected" || state.onboarding_status === "blocked"
    ? "bg-red-50 border-red-200 text-red-900"
    : "bg-amber-50 border-amber-200 text-amber-900";

  return (
      <div className={`${tone} border px-4 py-3 text-xs`}
           data-testid="vognmand-compliance-banner">
        <AlertCircle size={14} className="inline mr-1"/>
        <span>
          Onboarding: <b>{STATUS_LABEL[state.onboarding_status]}</b>
          {state.blocking_reasons?.length > 0 && ` · mangler ${state.blocking_reasons.length} skridt`}
          {state.rejection_reason && ` · ${state.rejection_reason}`}
        </span>
        {state.blocking_reasons?.includes?.("at_least_one_vehicle_approved") && !state.vehicle_requirement_exempt && (
          <div className="mt-1 text-amber-900 font-semibold" data-testid="banner-vehicle-missing">
            ⚠ Du mangler at få godkendt mindst ét køretøj, før du kan modtage ruter.
          </div>
        )}
        <a href="/vognmand/onboarding" data-testid="vognmand-compliance-cta"
           className="font-bold inline-flex items-center gap-1 hover:underline ml-2">
          Åbn onboarding <ChevronRight size={12}/>
        </a>
      </div>
    );
}
